export default __webpack_public_path__ + "static/media/new-tab-16px.68bdb2f2.svg";